import { ServiceHandler } from "./storageHandlers";
import { AssistantValue } from "../../../../api/instances/assistantsApi/types";
import { AgentValue } from "../../../../api/instances/agentsApi/types";
import { setAgentValue } from "../../../../../features/Agents/redux/slice";
import { deleteAgent } from "../../../../api/instances/agentsApi/api";
import { updateAgentUrlAction } from "../../../../../features/Agents/redux/actions";

export const AgentService: ServiceHandler = {
  async onUpdate(listenerApi, id, value, meta) {
    const { selectedId } = listenerApi.getState().storageObjectState.assistants;
    const { storeType } = listenerApi.getState().databaseState;
    const assistantValue = value as AssistantValue;
  },
  async onSelect(listenerApi, id, value) {
    if (id === null || value === null) return;
    const agentValue = value as AgentValue;
    listenerApi.dispatch(setAgentValue(agentValue));
    try {
      if (agentValue && agentValue.agent_object) {
        listenerApi.dispatch(updateAgentUrlAction(agentValue.agent_object.uid));
        return;
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
  async onDelete(listenerApi, id, value) {
    if (id === null || value === null) return;
    const agentValue = value as AgentValue;
    try {
      if (agentValue && agentValue?.agent_object?.uid) {
        await deleteAgent(agentValue?.agent_object?.uid as string);
      }
    } catch (e) {
      console.error("Нет объекта с таким ID");
    }
  },
};
